import MagazineIndex from "./magazine/list";
import CommunityIndex from "./community/list";

export default props => {
    // console.log("MagazineIndex: ");
    if (process.browser && window.location.href.indexOf("localhost") > 1) window.location.href ="/community/list";
    return <MagazineIndex />;
};


// 매거진, 커뮤니티 랜덤이동, 네이버검색엔진 크롤링문제로 당분간 제거해본다.
// if(process.browser)window.location.href = '' + (Math.random() > .5 ? '/community/list' : '/magazine/list');
